import axios from 'axios'

export const API_URL =
  process.env.NUXT_ENV_DJANGO_ADDRESS || 'http://localhost:8000/'

export const client = axios.create({
  baseURL: API_URL,
  timeout: 100000,
})
